import React from 'react';
import PropTypes from 'prop-types';
import {
  InputText,
  Radio,
} from '@othermachines/react-form-kit';

import {
  Fieldset,
} from '../../../Shared';

import {
  inputTheme,
  inputThemeShort,
  radioTheme,
} from '../../../lib';


const formName = 'Date Stamps';

const defaultValues = {
  'Quantity': '',
  'Size': '',
  'Graphics': '',
  'Regular-or-self-inking': '',
  'Replacement-cartridge': '',
  'Colour': '',
};

const fields = [
  'Quantity',
  'Size',
  'Graphics',
  'Regular-or-self-inking',
  'Replacement-cartridge',
  'Colour',
];

const Component = ({
  submitForm: {
    control,
    formState,
    register,
    setValue,
    unregister,
    watch,
  },

}) => {

  return (
    <Fieldset legend={formName}>

      <InputText
        inputTextId='Quantity'
        inputTextName='Quantity'
        register={register}
        formState={formState}
        label='Quantity'
        theme={inputThemeShort}
      />

      <InputText
        inputTextId='Size'
        inputTextName='Size'
        register={register}
        formState={formState}
        label='Size'
        theme={inputTheme}
      />

      <Radio
        radioId='Graphics'
        radioName='Graphics'
        legend='Graphics?'
        options={[
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' },
        ]}
        register={register}
        formState={formState}
        columns={2}
        theme={radioTheme}
      />

      <Radio
        radioId='Regular-or-self-inking'
        radioName='Regular-or-self-inking'
        legend='Regular or self-inking?'
        options={[
          { value: 'regular', label: 'Regular' },
          { value: 'self-inking', label: 'Self-inking' },
        ]}
        register={register}
        formState={formState}
        columns={2}
        theme={radioTheme}
      />

      <Radio
        radioId='Replacement-cartridge'
        radioName='Replacement-cartridge'
        legend='Do you require a replacement ink cartridge?'
        options={[
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' },
        ]}
        register={register}
        formState={formState}
        columns={2}
        theme={radioTheme}
      />

      <InputText
        inputTextId='Colour'
        inputTextName='Colour'
        register={register}
        formState={formState}
        label='If you need a replacement ink cartridge, what colour?'
        theme={inputTheme}
      />

    </Fieldset>
  );
};

Component.propTypes = {
  submitForm: PropTypes.shape({
    control: PropTypes.object.isRequired,
    formState: PropTypes.object.isRequired,
    register: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    unregister: PropTypes.func.isRequired,
    watch: PropTypes.func.isRequired,
  }).isRequired,
};

export default Component;
export { defaultValues, fields, formName };

